import { PatientPortalBookServiceError } from '../../generated/graphql';

export const portalBookErrorMessage = (
  error?: PatientPortalBookServiceError | null,
) => {
  switch (error) {
    case PatientPortalBookServiceError.ServiceNotBookableByExistingClients:
      return 'This service is not available for existing clients.';
    case PatientPortalBookServiceError.ServiceNotEnabled:
    case PatientPortalBookServiceError.ServiceNotFound:
      return 'This service is no longer available.';
    case PatientPortalBookServiceError.ProviderMismatch:
      return 'This service belongs to a different provider.';
    case PatientPortalBookServiceError.NoActiveProgram:
      return 'No active program found. Contact your provider.';
    default:
      return 'Could not book this service. Please try again.';
  }
};
